import React from 'react';
import './LoadingSpinner.css'; // Create this file

const LoadingSpinner = ({ size = 'large', text = '' }) => {
  return (
    <div className={`loading-spinner-container ${size}`}>
      <div className="spinner"></div>
      {text && <p>{text}</p>}
    </div>
  );
};
export default LoadingSpinner;